import { Routes } from '@angular/router';

export const Home_Routes: Routes = [
  {
    path: '',
    loadChildren: () => import('app/modules/home/pages/home/home.module').then(m => m.HomeModule),
  },
];
